<template>
    <v-dialog v-model="dialog" eager max-width="600px" persistent>
        <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
                <slot>
                    <v-btn icon text class="grey--text px-0 rounded-btn" :title="$t('Выбрать договор')" dense>
                        <v-icon>edit</v-icon>
                    </v-btn>
                </slot>
            </div>
        </template>

        <LabeledCard :label="$t('Выбрать договор')">
            <section id="search-contract-table">
                <v-container>
                    <v-row dense>
                        <v-col>
                            <v-text-field
                                append-icon="mdi-magnify"
                                autocomplete="off"
                                dense
                                @input="onInput"
                                @keydown.enter="onInput($event.target.value)"
                                :loading="isLoading"
                                outlined
                                :placeholder="$t('Введите наименование договора')"
                                v-model.trim="searchString"
                                hide-details
                            />
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col>
                            <v-data-table
                                class="pt-4"
                                :headers="headers"
                                :items="ContractTrans"
                                :options.sync="options"
                                :server-items-length="ContractLength"
                                fixed-header
                                :hide-default-footer="!ContractLength || ContractLength == 0"
                                :footer-props="{ 'items-per-page-options': $vuetify.breakpoint.xsOnly ? [1] : [3] }"
                                :loading="isLoading"
                            >
                                <template #item="{ item }">
                                    <tr
                                        @click="onRowClicked(item)"
                                        @dblclick="onDoubleClick"
                                        :class="{ active: selectedContract && item.contract_rid === selectedContract.contract_rid }"
                                    >
                                        <td class="pointer no-user-select">{{ item.contract_number }}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col :class="{ 'd-flex align-center justify-end': true, 'flex-column-reverse w100': $vuetify.breakpoint.xsOnly }">
                            <v-btn
                                outlined
                                color="primary"
                                :class="{ 'rounded-btn px-5 mt-3 mt-sm-0': true, ' w100': $vuetify.breakpoint.xsOnly }"
                                @click="dialog = false"
                                >{{ $t('Закрыть') }}</v-btn
                            >
                            <v-btn
                                @click="selectClick"
                                color="info"
                                :class="{ 'rounded-btn ml-sm-2 px-5': true, ' w100': $vuetify.breakpoint.xsOnly }"
                                :disabled="!selectedContract || this.Contract.length == 0"
                                >{{ $t('выбрать') }}</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-container>
            </section>
        </LabeledCard>
    </v-dialog>
</template>

<script>
import LabeledCard from '../ui/LabeledCard';
import { mapState, mapActions } from 'vuex';
import translate from '@/utils/translate.util';
import { wait } from '@/utils';

export default {
    components: { LabeledCard },
    data: () => ({
        dialog: false,
        isLoading: false,
        searchString: '',
        selectedContract: {},
        options: {
            groupBy: [],
            groupDesc: [],
            itemsPerPage: 3,
            multiSort: false,
            mustSort: false,
            page: 0,
            sortBy: [],
            sortDesc: []
        }
    }),
    methods: {
        ...mapActions('users', ['getContract']),
        async onInput(text) {
            if (text.length < 1) {
                this.$store.commit('users/setContract', []);
                this.$store.commit('users/setContractLength', 0);
                this.selectedContract = {};
                return;
            }
            await wait(1000);
            if (text !== this.searchString) return;

            this.options.page = 1;
            this.search(true);
        },
        async search(newSearch) {
            this.isLoading = true;

            const searchResult = await this.getContract({
                req: {
                    contract_rid: null,
                    searchLine: this.searchString,
                    itemsPerPage: this.options.itemsPerPage,
                    currentItem: newSearch ? 0 : this.options.page - 1
                }
            });
            this.searchResult = searchResult;
            this.isLoading = false;
        },
        async onRowClicked(item) {
            this.selectedContract = {
                ...item,
                isas_contract_rid: item.contract_rid,
                isas_contractor_rid: item.contractor_rid
            };
        },
        onDoubleClick() {
            this.selectClick(); // выбор договора производится при первым клике
        },
        async selectClick() {
            const rid = this.selectedContract;
            this.$store.commit('users/setSelectedContract', rid);
            this.$emit('input', this.selectedContract);


            this.dialog = false;
        },

        clearSelection() {
            this.selectedContract = {};
            this.$store.commit('users/setSelectedContract', {});
            this.$emit('input', {});
        }
    },
    computed: {
        ...mapState('users', ['Contract', 'ContractLength']),
        ContractTrans() {
            return translate(this.Contract, 'full', this.$i18n.locale);
        },
        headers: function() {
            return [
                {
                    text: this.$t('Договор'),
                    value: 'isas_Contract_name',
                    sortable: false
                }
            ];
        }
    },
    watch: {
        async dialog() {
            this.$store.commit('users/setContract', []);
            this.$store.commit('users/setContractLength', 0);
            this.searchString = '';
            this.selectedContract = {};
        }
    }
};
</script>
